<template>
  <div>
    <b-container class="container-box">
      <b-row class="no-gutters">
        <b-col xl="5" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">ภาพรวมการสั่งซื้อ</h1>
        </b-col>
        <b-col xl="7" class="text-right d-flex justify-content-end">
          <FinanceOrderFilter
            v-on:onSubmitFilter="submitFilter"
            v-on:onSearch="search"
            :status="status"
            :filter="filter"
            ref="financeFilter"
          />
        </b-col>
      </b-row>
      <b-tabs content-class="mt-0" class="mt-3 finance-tabs">
        <b-tab
          v-for="(item, index) in status"
          :key="index"
          :title="item.name + ' (' + item.count + ')'"
          :active="isActive(item.id)"
          @click="selectTab(item.id)"
        >
        <Table
          ref="FinanceComponent"
          :getFinanceOrderList="getFinanceOrderList"
          :items="items"
          :rows="rows"
          :filter="filter"
          :isBusy="isBusy"
        />
        </b-tab>
      </b-tabs>
    </b-container>
  </div>
</template>

<script>
import FinanceOrderFilter from "../finance-order-list/components/Filter.vue";
import Table from "../finance-order-list/components/Table.vue";

export default {
  components: {
    FinanceOrderFilter,
    Table 
  },
  data() {
    return {
      activeItem: "",
      status: [],
      filter: {
        page : 1,
        take : 10,
        market: "",
        keyword : "",
        startDate : "",
        endDate : "",
        saleChannelId : "",
        statementPaymentId: "",
        paymentStatusIds : []
      },
      items: [],
      rows: null,
      isBusy: false,
      marketList: []
    };
  },
  created() {
    this.getFinanceOrderList()
  },
  methods: {
    getFinanceOrderList() {
      this.isBusy = true
      this.axios.post(`${this.$baseUrl}/statement/StatementOrderList`, this.filter).then((response) => {
        if (response.result === 1) {
          console.log('response', response);
          this.items = response.detail.data
          this.status = response.detail.status
          this.rows = response.detail.count
          this.isBusy = false
        }
      });
    },
    submitFilter(filter) {
      if (filter !== undefined) {
        this.filter.saleChannelId = filter.market
        if (filter.startDate !== "") {
          this.filter.startDate = this.$moment(filter.startDate).format("YYYY-MM-DD") 
        }
        if (filter.endDate !== "") {
          this.filter.endDate = this.$moment(filter.endDate).format("YYYY-MM-DD")
        }
        this.filter.keyword = filter.search
        this.filter.paymentStatusIds = filter.paymentStatusIds
      }
      this.getFinanceOrderList();
    },
    search(search) {
      this.filter.keyword = search
      this.getFinanceOrderList();
    },
    isActive(menuItem) {
      return this.activeItem == menuItem;
    },
    selectTab (id) {
      if (id === 0) {
        this.filter.paymentStatusIds = []
      } else {
        this.filter.paymentStatusIds = [id]
      }
      this.filter.search = ""
      this.filter.startDate = ""
      this.filter.endDate = ""
      this.filter.market = ""
      this.filter.statementPaymentId = ""
      this.filter.page = 1
      this.filter.take = 10
      this.paymentStatusIdsAll = false
      this.getFinanceOrderList();
    }
  },
};
</script>

<style></style>
